import { Inject, Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserServiceInterface } from '@hutsix/ngxh6';

@Injectable({
    providedIn: 'root',
})
export class CspAuthGuardService {
    constructor(
        private router: Router,
        @Inject('UserService') public user: UserServiceInterface,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        // do some checks here
        return this.user.watch.pipe(
            map(user => {
                if (!user || !user.loggedIn) {
                    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                    return false;
                }

                if (route.data?.roles?.length && !this.user.isGranted(route.data.roles)) {
                    this.router.navigate(['/unauthorised'], { queryParams: { route: state.url } });
                    return false;
                }

                let isCspUser = false;
                // Allow access if user roles includes 'CSP'
                if (user && user.account.user.roles) {
                    isCspUser = user.account.user.roles.some((role: string) => role.includes('CSP') || role.includes('ROLE_ADMIN'));
                }

                return isCspUser;
            }),
        );
    }
}
